<template>
  <div
      class="autocomplete-popup__input-container-group q-input-group q-mb-1 q-input-group-lg q-d-flex q-flex-nowrap"
      role="search" aria-label="Wyszukiwanie"
      v-show="!isMobileView || !isBridgeActive || showAutocompletePopup"
  >
    <ClosePopupButton v-if="showAutocompletePopup" />
    <SearchInput
        v-if="shouldRenderDesktopInput"
        ref="desktopInputRef"
        :autocomplete="true"
        context="desktop"
    />
    <SearchInput
        v-if="shouldRenderMobileInput"
        ref="mobileInputRef"
        :autocomplete="true"
        context="mobile"
    />
  </div>
</template>

<script setup lang="ts">
import {computed, nextTick, onMounted, onUnmounted, ref, watch} from 'vue'
import {storeToRefs} from "pinia";
import SearchInput from "@/components/SearchInput.vue";
import ClosePopupButton from './ClosePopupButton.vue'
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useBridgeStore} from "@/store/BridgeStore";

const popupStore = usePopupStore()
const {showAutocompletePopup} = storeToRefs(popupStore)

const mobileViewStore = useMobileViewStore()
const {isMobileView} = storeToRefs(mobileViewStore)

const bridgeStore = useBridgeStore()

const desktopInputRef = ref<InstanceType<typeof SearchInput> | null>(null)
const mobileInputRef = ref<InstanceType<typeof SearchInput> | null>(null)

const isBridgeActive = computed(() => bridgeStore.hasClientInput)

const shouldRenderDesktopInput = computed(() => !isMobileView.value && !isBridgeActive.value)
const shouldRenderMobileInput = computed(() =>
  isMobileView.value && (!isBridgeActive.value || showAutocompletePopup.value)
)

const focusActiveInput = () => {
  if (isMobileView.value) {
    mobileInputRef.value?.focusInput()
    return
  }

  if (!isBridgeActive.value) {
    desktopInputRef.value?.focusInput()
  }
}

watch(showAutocompletePopup, async (isOpen) => {
  if (!isOpen) {
    return
  }

  await nextTick()
  focusActiveInput()
})

watch(isMobileView, (isMobile) => {
  if (isMobile && showAutocompletePopup.value) {
    nextTick(() => focusActiveInput())
  }
})

onMounted(() => {
  bridgeStore.registerInternalInputFocusHandler(focusActiveInput)
})

onUnmounted(() => {
  bridgeStore.clearInternalInputFocusHandler()
})
</script>
